import React, { useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import LoginForm from './LoginForm';
import RegistrationForm from './RegistrationForm';
import Header from './Header';

function SignInUp() {
  const [isRegistrationActive, setIsRegistrationActive] = useState(false);

  const handleToggle = () => {
    setIsRegistrationActive(!isRegistrationActive);
  };

  return (
    <div className="auth-page">
      <Header />
      
      <div className="auth-container">
        <Container>
          <Row className="justify-content-center align-items-center min-vh-80">
            <Col lg={5} md={7} sm={9}>
              <div className="auth-card">
                <div className="auth-header">
                  <h2 className="auth-title">
                    {isRegistrationActive ? 'Create Account' : 'Welcome Back'}
                  </h2>
                  <p className="auth-subtitle">
                    {isRegistrationActive 
                      ? 'Join Press Forward Mail to stay connected with your missionary'
                      : 'Sign in to manage your missionary communications'
                    }
                  </p>
                </div>
                
                <div className="auth-form">
                  {isRegistrationActive ? <RegistrationForm /> : <LoginForm />}
                </div>
                
                <div className="auth-toggle">
                  <Button 
                    variant="link" 
                    className="toggle-btn"
                    onClick={handleToggle}
                  >
                    {isRegistrationActive 
                      ? 'Already have an account? Sign in' 
                      : "Don't have an account? Sign up"
                    }
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default SignInUp;
